import { render } from "./DoctorReceptionWidget.vue?vue&type=template&id=62b83c4f&ts=true&lang=pug"
import script from "./DoctorReceptionWidget.vue?vue&type=script&setup=true&lang=ts"
export * from "./DoctorReceptionWidget.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__